






























import { Component, Vue } from 'vue-property-decorator';
import Chat from '@/components/room/status/chatList/chat/Chat.vue';
import ChatListHeader from '@/components/room/status/chatList/ChatListHeader.vue';
import GroupChatButton from '@/components/room/status/chatList/GroupChatButton.vue';
import UserChatButton from '@/components/room/status/chatList/UserChatButton.vue';
import { store } from '@/utils/store';
import { getGroupChatId } from '@/utils/utils';

@Component({
  components: {
    Chat,
    ChatListHeader,
    GroupChatButton,
    UserChatButton,
  },
})
export default class ChatList extends Vue {
  currentId = ''

  get groupId() {
    return getGroupChatId(store.roomId ?? '');
  }

  get users() {
    return store.users;
  }

  get selfId() {
    return store.githubId;
  }

  open(id: string): void {
    this.currentId = id;
  }

  close(): void {
    this.currentId = '';
  }
}
